import React, { Component } from 'react';
import TimelineToothComponent from './TimelineToothComponent';

export default class ChartingTimeline extends Component {
    state = {
        timeline: [],
        toothId: ''
    };

    handleCloseModal = () => {

    };

    componentWillMount() {

    }

    componentDidMount() {
        if (this.props.timeline.length > 0) {
            this.setState({
                timeline: this.props.timeline,
                toothId: this.props.toothId
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.timeline.length > 0) {
            this.setState({
                timeline: nextProps.timeline,
                toothId: nextProps.toothId
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.timeline.length <= 0) {
            return false;
        }

        return true;
    }

    handleVoidHistory = (index) => {
        let timeline = this.state.timeline;
        timeline.splice(index, 1);
        
        this.setState({timeline});
    }

    render() {
        let timeline = this.state.timeline;
        let toothId = this.state.toothId;

        return (
            <div id="chartingTimelineModal" data-width="760" className="modal fade in"
                 tabIndex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">

                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={this.handleCloseModal}
                                data-dismiss="modal" aria-hidden="true"/>

                        <h4 className="modal-title">Tooth #{toothId} history</h4>
                    </div>
                    <div className="modal-body">
                        <div className="row">

                            {timeline.map((item, i) =>  {
                                return (
                                    <div className="col-md-12" key={i}>
                                        <TimelineToothComponent
                                            toothId={toothId}
                                            color='transparent'
                                            toothData={[item]}
                                            index={i}
                                            onVoidHistory={this.handleVoidHistory} />

                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn dark btn-outline" onClick={this.handleCloseModal}
                                data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Charting/ChartingTimeline.js
 **/